import React from "react";
import { Edit2, Trash2 } from "lucide-react";

export default function ProgramacionItem({ prog, getSectorName, onEdit, onDelete }) {
  const { type, schedule, valves } = prog.configuracion.parameters;
  const { weekly, cyclic } = schedule;

  // Datos de encabezado según tipo
  const topData =
    type === "semanal"
      ? [
          { label: "Hora inicio", value: weekly.startTime },
          { label: "Ciclos/día", value: weekly.cyclesPerDay },
          { label: "Intervalo", value: weekly.intervalTime },
          { label: "Días", value: weekly.days.join(", ") },
        ]
      : [
          { label: "Fecha inicio", value: cyclic.startDate.split("T")[0] },
          { label: "Hora inicio", value: cyclic.startTime },
          { label: "Intervalo (días)", value: cyclic.daysInterval },
          { label: "Ciclos/día", value: cyclic.cyclesPerDay },
          { label: "Entre ciclos", value: cyclic.intervalTime },
        ];

  return (
    <article className="relative group rounded-2xl border border-white/20 bg-white/10 backdrop-blur shadow-lg p-5 hover:ring-2 hover:ring-blue-300 transition">
      {/* Botones de acción, juntos en esquina superior derecha */}
      <div className="absolute top-3 right-3 flex space-x-2 opacity-0 group-hover:opacity-100 transition">
        <button
          onClick={() => onEdit(prog)}
          className="p-2 bg-white/20 hover:bg-white/30 rounded-md focus:outline-none transition"
          title="Editar"
        >
          <Edit2 size={16} className="text-yellow-400" />
        </button>
        <button
          onClick={() => onDelete(prog)}
          className="p-2 bg-white/20 hover:bg-white/30 rounded-md focus:outline-none transition"
          title="Eliminar"
        >
          <Trash2 size={16} className="text-red-400" />
        </button>
      </div>

      {/* Encabezado */}
      <h3 className="text-lg font-bold mb-2 flex items-center gap-2">
        <span className="text-xl">📄</span> #{prog.programacionId}
        <span className="text-xs font-normal px-2 py-0.5 bg-blue-600/30 rounded-full capitalize">
          {type}
        </span>
      </h3>

      {/* Tabla datos principales */}
      <div className="mb-3">
        <div className="rounded-xl bg-blue-900/60 border border-blue-300/40 backdrop-blur-[2px] overflow-hidden">
          <table className="min-w-full text-xs text-white table-fixed">
            <tbody>
              {topData.map((row) => (
                <tr key={row.label} className="border-b border-blue-300/30 last:border-b-0">
                  <td className="py-2 px-3 font-bold w-36 bg-blue-800/70">
                    {row.label}
                  </td>
                  <td className="py-2 px-3">{row.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Tabla válvulas */}
      <div className="mt-4">
        <div className="rounded-xl bg-cyan-800/60 border border-blue-300/40 backdrop-blur-[2px] overflow-hidden">
          <table className="min-w-full text-xs text-blue-50">
            <thead>
              <tr className="bg-cyan-900/70 border-b border-blue-300/30">
                <th className="py-2 px-3 text-left">Sector</th>
                <th className="py-2 px-3 text-left">Válvula</th>
                <th className="py-2 px-3 text-left">Duración</th>
              </tr>
            </thead>
            <tbody>
              {valves.map((v, i) => (
                <tr key={i} className={i % 2 === 0 ? "bg-cyan-900/30" : "bg-cyan-900/50"}>
                  <td className="py-1 px-3">{getSectorName(v.valvulaId)}</td>
                  <td className="py-1 px-3">{v.valvulaId}</td>
                  <td className="py-1 px-3">{v.duration}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </article>
  );
}
